import {css, getHoverColor, getActiveColor} from '../utils.js';

const styles = css`
    .ddk-container .layout-accordion-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        background-color: ${({theme}) => theme.background_page};
    }

    .ddk-container .accordion-header {
        display: flex;
        cursor: pointer;
        height: 56px;
        padding: var(--ddk-padding-sm, 16px) var(--ddk-padding-xs, 8px);
        align-items: center;
        gap: var(--ddk-grid-1, 8px);
        align-self: stretch;
        background-color: ${({theme}) => theme.background_page};
        position: sticky;
        top: 0;
        z-index: 2;
    }

    .ddk-container .accordion-header .accordion-toggle-button {
        color: ${({theme}) => theme.accent};
        transition: transform 0.3s ease-in-out;
        cursor: pointer;
        -webkit-user-select: none;
        user-select: none;
    }

    .ddk-container .accordion-header:hover,
    .ddk-container .accordion-header:focus {
        background-color: ${({theme}) =>
            getHoverColor(
                theme.card_header_background_color,
                theme.color_scheme
            )};
    }
    .ddk-container .accordion-header:hover .accordion-toggle-button,
    .ddk-container .accordion-header:focus .accordion-toggle-button {
        color: ${({theme}) => getHoverColor(theme.accent, theme.color_scheme)};
    }
    .ddk-container .accordion-header:active {
        background-color: ${({theme}) =>
            getActiveColor(
                theme.card_header_background_color,
                theme.color_scheme
            )};
    }
    .ddk-container .accordion-header:active .accordion-toggle-button {
        color: ${({theme}) => getActiveColor(theme.accent, theme.color_scheme)};
    }

    .ddk-container .accordion-header .accordion-toggle-button.collapsed {
        transform: rotate(-90deg);
    }

    .ddk-container .accordion-header .accordion-title {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        flex: 1 0 0;

        overflow: hidden;
        color: ${({theme}) => theme.text ?? 'var(--ddk-text-base-primary)'};
        font-family: ${({theme}) => theme.font_family};
        font-size: ${({theme}) =>
            theme.font_size ?? 'var(--ddk-font-size-md, 16px)'};
        text-overflow: ellipsis;
        font-style: normal;
        font-weight: 500;
        line-height: 150%; /* 24px */
        letter-spacing: 0.024px;
    }

    .ddk-container .accordion-header .accordion-tag {
        /* We are going to hide the tag for now, since we have yet to determine
        the exact behavior we want it to exhibit. Does it show the number of
        controls in the panel, or just the number of controls that are "active"
        / differ from their default state? */
        display: none; /* display: flex; */
        padding: var(--ddk-grid-half, 4px) var(--ddk-grid-1, 8px);
        align-items: center;
        gap: var(--ddk-grid-half, 4px);

        font-family: ${({theme}) => theme.font_family};
        font-size: ${({theme}) =>
            theme.tag_font_size ?? 'var(--ddk-font-size-sm)'};
        background-color: ${({theme}) => theme.background_page};
        border: 1px solid ${({theme}) => theme.card_border.color};
        color: ${({theme}) =>
            theme.tag_text ?? 'var(--ddk-text-text-secondary, #646464)'};
        border-radius: ${({theme}) =>
            theme.tag_border?.radius ?? 'var(--ddk-radius-sm)'};
    }

    .ddk-container .accordion-slide-wrapper {
        width: 100%;
        display: grid;
        grid-template-rows: 1fr;
        transition: grid-template-rows 0.3s ease-in-out;
    }

    .ddk-container .accordion-slide-wrapper.collapsed {
        grid-template-rows: 0fr;
    }

    /** 
    * This content wrapper allows us to animate our transition when the accordion opens.
    * chriscoyier.net/2022/12/21/things-css-could-still-use-heading-into-2023/#animate-to-auto 
    */
    .ddk-container .accordion-content-wrapper {
        overflow: hidden;
    }

    .ddk-container .accordion-content {
        display: flex;
        padding: 8px 8px 24px 8px;
        flex-direction: column;
        align-items: flex-start;
        gap: var(--ddk-grid-2, 16px);
        align-self: stretch;
    }

    .ddk-container .accordion-content .accordion-description {
        align-self: stretch;
        color: ${({theme}) =>
            theme.hero_controls_label_text ??
            'var(--ddk-color-base-base70, #464646)'};

        /* Body1 */
        font-family: ${({theme}) => theme.font_family};
        font-size: ${({theme}) =>
            theme.font_size ?? 'var(--ddk-font-size-md, 16px)'};
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 24px */
        letter-spacing: 0.08px;
    }

    .ddk-container .accordion-content .accordion-controls-grouping {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        gap: var(--ddk-grid-2, 16px);
        align-self: stretch;
    }
`;

export default styles;
